import * as React from 'react';

function DefaultIcon(props) {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={71.727}
            height={72.36}
            viewBox='0 0 463 463'
            {...props}
        >
            <g>
                <path d="M175.5,0h-136C17.72,0,0,17.72,0,39.5v136C0,197.28,17.72,215,39.5,215h136c21.78,0,39.5-17.72,39.5-39.5v-136
		C215,17.72,197.28,0,175.5,0z M200,175.5c0,13.509-10.991,24.5-24.5,24.5h-136C25.991,200,15,189.009,15,175.5v-136
		C15,25.991,25.991,15,39.5,15h136c13.509,0,24.5,10.991,24.5,24.5V175.5z" fill='#fff' />
                <path d="M423.5,0h-136C265.72,0,248,17.72,248,39.5v136c0,21.78,17.72,39.5,39.5,39.5h136c21.78,0,39.5-17.72,39.5-39.5v-136
		C463,17.72,445.28,0,423.5,0z M448,175.5c0,13.509-10.991,24.5-24.5,24.5h-136c-13.509,0-24.5-10.991-24.5-24.5v-136
		c0-13.509,10.991-24.5,24.5-24.5h136c13.509,0,24.5,10.991,24.5,24.5V175.5z" fill='#fff' />
                <path d="M175.5,248h-136C17.72,248,0,265.72,0,287.5v136C0,445.28,17.72,463,39.5,463h136c21.78,0,39.5-17.72,39.5-39.5v-136
		C215,265.72,197.28,248,175.5,248z M200,423.5c0,13.509-10.991,24.5-24.5,24.5h-136C25.991,448,15,437.009,15,423.5v-136
		c0-13.509,10.991-24.5,24.5-24.5h136c13.509,0,24.5,10.991,24.5,24.5V423.5z" fill='#fff' />
                <path d="M423.5,248h-136c-21.78,0-39.5,17.72-39.5,39.5v136c0,21.78,17.72,39.5,39.5,39.5h136c21.78,0,39.5-17.72,39.5-39.5v-136
		C463,265.72,445.28,248,423.5,248z M448,423.5c0,13.509-10.991,24.5-24.5,24.5h-136c-13.509,0-24.5-10.991-24.5-24.5v-136
		c0-13.509,10.991-24.5,24.5-24.5h136c13.509,0,24.5,10.991,24.5,24.5V423.5z" fill='#fff' />
            </g>
        </svg>
    );
}
export default DefaultIcon;
